import _get from 'lodash/get';

const defaultShift = {};

const getShift = (store) => {
  return _get(store, ['shifts', 'data', 0], defaultShift);
};

export { getShift };
